export const LOGIN_MAP: any = {
    ECOFLOW_WEB_COMMUNITY: 'ECOFLOW_WEB_COMMUNITY',
};

export const SUBSCRIBE_MAP: any = {
    ECOFLOW_WEB_COMMUNITY: 'ECOFLOW_COMMUNITY',
};

export const FORUM_APPID_MAP: any = {
    us: '201',
    uk: '202',
    au: '203',
    ca: '204',
    jp: '205',
    fr: '206',
    de: '207',
    kr: '208',
    eu: '209',
    es: '211',
    it: '213',
    za: '215',
    sa: '216',
    br: '218',
    pl: '221',
    se: '222',
    mx: '224',
    ph: '225',
};
